export enum LandingStepErrorsEnum {
  PassengerAlreadyRegistered = "PassengerAlreadyRegistered",
  PassengerIsProbablyBlocked = "PassengerIsProbablyBlocked",
  PassengerIsNotEligible = "PassengerIsNotEligible",
  GeneralError = "GeneralError",
}
